import React from "react";
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import {
  success,
  warning,
  successNotification,
  error,
  errorNotification,
  warningNotification,
  info,
  infoNotification,
} from "../notification/notifications";
import { InstituteService } from "../../services/fetchInstitute";

class questionnaire extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();

    console.log(props);
    this.state = {
      answerType: [],
      showOptions: "none",
      correctAnswer: [],
      returnChild: true,
      // totalScore: 0,
      // minScore: "",
    };
    if (
      props.questionnaireDataProp
        ? props.questionnaireDataProp.length > 0
        : false
    ) {
      let a = this.initialValues;
      let questionProp = props.questionnaireDataProp;
      let quentionInitailValues = { questionnaire: [] };

      questionProp.map((item, index) => {
        let tempObj = {};

        tempObj.questionTitle = item.questionTitle;
        tempObj.resTypeId = item.resTypeId.toString();
        tempObj.correctAnswer = item.correctAnswer ? item.correctAnswer : "";
        tempObj.score = item.score ? item.score.toString() : "";
        // tempObj.attemptOnly =
        //   item.attemptOnly !== null ? item.attemptOnly.toString() : "";
        let tempStr = "";

        if (
          item.optionDescEntityList
            ? item.optionDescEntityList.length > 0
            : false
        ) {
          item.optionDescEntityList.map((item, index, arr) => {
            // debugger;
            //tempStr =  tempStr.concat(item.optionDesc + ",")

            if (arr.length - 1 === index) {
              // last one
              tempStr = tempStr.concat(item.optionDesc);
            } else {
              // not last one
              tempStr = tempStr.concat(item.optionDesc + ",");
            }
          });
        }

        tempObj.optionDesc = tempStr;

        quentionInitailValues.questionnaire.push(tempObj);
      });
      this.initialValues = quentionInitailValues;
    }
  }

  initialValues = {
    questionnaire: [
      {
        questionTitle: "",
        resTypeId: "",
        optionDesc: "",
        correctAnswer: "",
        score: 0,
        idx: "",
        // attemptOnly: "",
      },
    ],
  };

  componentDidMount() {
    InstituteService.fetchAnswerType((res) => {
      if (res.status === "success") {
        this.setState({ answerType: res.responseListObject });
      }
    });
  }

  createPayload(formData) {
    let payload = [];

    formData.map((item, index) => {
      let tempPayload = {};
      let optionsArr = item.optionDesc ? item.optionDesc : "";
      let optionList = [];

      if (optionsArr.length > 0) {
        optionsArr.map((item, index) => {
          let optionObj = {};
          optionObj.optionDesc = item;
          optionList.push(optionObj);
        });
      }

      tempPayload.questionTitle = item.questionTitle;
      // tempPayload.attemptOnly = item.attemptOnly;
      tempPayload.resTypeId = item.resTypeId;
      tempPayload.correctAnswer = item.correctAnswer ? item.correctAnswer : "";
      tempPayload.score = item.score ? item.score : 0;
      tempPayload.optionDescEntityList = optionList;
      // tempPayload.minScore = this.state.minScore;
      console.log(tempPayload);

      payload.push(tempPayload);
    });
    console.log(payload);
    return payload;
  }

  onSubmit = async (values,index1,actionType) => {
    await new Promise((r) => setTimeout(r, 500));
    //const values = this.initialValues
    // debugger;
    console.log(values);
    let newForm = [];
    let newTotalScore = 0;
    // alert(JSON.stringify(values, null, 2));
    console.log("values", values.questionnaire.optionDesc);

    if(values.questionnaire.length === 0){      
      success(`All Questions Removed `, successNotification);      
    }

    values.questionnaire.map((item, index) => {
      console.log("item", item);
      console.log("option Desc", item.optionDesc);

      newTotalScore += parseInt(item.score);
      // let questionTitleRegex = /^\S([a-zA-Z0-9 .?,]{1,100})?$/gm;
      let questionTitleRegex = /^[a-zA-Z0-9.,?]+[a-zA-Z0-9\s.,?]*$/;
      // /^[a-zA-Z0-9.]+[a-zA-Z0-9\s.]*$/,
      let scoreRegex = /^([0-5]{1})$/gm;
      // debugger
      if (item.questionTitle === "" || item.questionTitle === undefined) {
        warning(
          "Add Question title on Question no." + (index + 1),
          warningNotification
        );
        return;
      }
      if(questionTitleRegex.test(item.questionTitle) === false){
        warning("First Space is Not Allowed,Characters,Numbers and Dot(.) Comma(,) Question Mark(?), Spaces are allowed in Question no." + (index + 1),warningNotification)
        return
      }
      if (item.resTypeId === "" || item.resTypeId === undefined) {
        warning(
          "Select Answer type on Question no." + (index + 1),
          warningNotification
        );
        return;
      }
      //! Attempt Only Warning
      // if (item.attemptOnly === "" || item.attemptOnly === undefined) {
      //   warning(
      //     "Select attempt only on Question no." + (index + 1),
      //     warningNotification
      //   );
      //   return;
      // }
      // if (item.attemptOnly === "0") {
      if (item.score === "" || item.score === undefined) {
        warning(
          "Please enter a score on Question no." + (index + 1),
          warningNotification
        );
        return;
      }
      if(scoreRegex.test(item.score) === false){
        warning("Enter numbers from 0 to 5 only. Decimals are not allowed.",warningNotification);
        return;
      }
      if (parseInt(item.score) > 5) {
        warning(
          "Please enter a score less than 5 on Question no." + (index + 1),
          warningNotification
        );
        return;
      }
      // }
      if (item.resTypeId !== "") {
        if (item.resTypeId !== "1") {
          if (item.optionDesc === "" || item.optionDesc === undefined) {
            warning(
              "Please enter an answer option on Question no." + (index + 1),
              warningNotification
            );
            return;
          }
          let regexOpt1 = /^([0-9a-zA-Z .?]*,[0-9a-zA-Z .?]*)$/gm;
          let regexOpt2 = /^([0-9a-zA-Z .?]*,[0-9a-zA-Z .?]*,[0-9a-zA-Z .?]*,[0-9a-zA-Z .?]*)$/gm;
          if (item.resTypeId === "2") {
            // console.log('regexOpt2.test(item.optionDesc',(/^([0-9a-zA-Z ]*,[0-9a-zA-Z ]*,[0-9a-zA-Z ]*,[0-9a-zA-Z ]*)$/g).test(item.optionDesc));
            if (regexOpt2.test(item.optionDesc) === false) {
              warning(
                "Enter only 4 Options for Question " + (index + 1) +" and only 3 Commas(,) , Dots(.) and Question Mark(?) is Allowed",
                // "Give Correct Options given below " + (index + 1),
                warningNotification
              );
              return;
            }
          } else {
            if (regexOpt1.test(item.optionDesc) === false) {
              warning(
                "Enter only 2 Options for Question " + (index + 1) +" and only 1 Comma(,) , Dot(.) and Question Mark(?) is Allowed",
                // "Give Correct Options given below " + (index + 1),
                warningNotification
              );
              return;
            }
          }
          if (item.correctAnswer === "" || item.correctAnswer === undefined) {
            warning(
              "Please select the correct answer on Question no." + (index + 1),
              warningNotification
            );
            return;
          }
        }
      }
      // if (
      //   this.state.minScore === "" ||
      //   this.state.minScore === 0 ||
      //   this.state.minScore === null ||
      //   this.state.minScore === undefined
      // ) {
      //   warning("Please Enter Minimum Eligible Score", warningNotification);
      //   return;
      // }
      // if (
      //   this.state.totalScore === "" ||
      //   this.state.totalScore === 0 ||
      //   this.state.totalScore === null ||
      //   this.state.totalScore === undefined
      // ) {
      //   warning("Please Enter Total Score", warningNotification);
      //   return;
      // }
      // if (this.state.minScore >= this.state.totalScore) {
      //   warning(
      //     "Minimum Eligible Score should be less than Total Score",
      //     warningNotification
      //   );
      //   return;
      // }

      if (item.questionTitle !== "") {
        success(`Question Saved  ${index + 1}!!!`, successNotification);      
      }
      // if (actionType === "add" && item.questionTitle !== "") {
      //   success(`Question Saved ${index + 1} !!!`, successNotification);
      // }
      // if (actionType === "remove") {
      //   success(`Question Removed ${index1 + 1}!!!`, successNotification);
      // }
    });
    // this.setState({
    //   totalScore: parseInt(newTotalScore),
    // });

    values.questionnaire.map((item, index) => {
      // debugger;
      let newItem = { ...item };
      let optionsArray = item.optionDesc ? item.optionDesc : "";
      optionsArray = optionsArray.split(",");

      if (optionsArray.length > 0) {
        newItem.optionDesc = optionsArray;
      }
      newForm.push(newItem);
    });

    console.log(newForm); //Array
    let payload = this.createPayload(newForm);
    //this.state.returnChild === true? this.props.parentCallback(values):  this.props.parentCallback(null); //Object
    //alert(JSON.stringify(payload, null, 2));

    this.state.returnChild === true
      ? this.props.parentCallback(payload, parseInt(newTotalScore))
      : this.props.parentCallback(null); //Array
  };

  render() {
    // console.log("question state", this.state);

    return (
      <React.Fragment>
        <div>
          <Formik
            initialValues={this.initialValues}
            validationSchema={Yup.object({
              questionnaire: Yup.array().of(
                Yup.object().shape({
                  interviewType: Yup.string().required(
                    "Please Select Interview Type"
                  ),
                  interviewTitle: Yup.string().required(
                    "Please enter stages to Proceed"
                  ),
                  // questionTitle: Yup.string()
                  //   .required("Please enter question")
                  //   .max(100, "Question not Greater than 100")
                  //   .matches(
                  //     // /^\S([a-zA-Z0-9 .?,]{1,100})?$/,
                  //     /^[a-zA-Z0-9.?,]+[a-zA-Z0-9\s.?,]*$/,
                  //     "Characters,Numbers and Dot(.) Comma(,) Question Mark(?) are allowed."
                  //     ),
                  // resTypeId: Yup.string().required(
                  //   "Please select question type"
                  // ),
                  // // score: Yup.number()
                  // // // /^([0-5]{1})$/,
                  // //   .required("Please enter score")
                  // //   .min(1, "Please enter Score greater than 1")
                  // //   .max(5, "Please enter Score less than 5"),
                  //   score: Yup.number()
                  // // /^([0-5]{1})$/,
                  //   .required("Please enter score").matches(/^([0-5]{1})$/,"Enter Number 0 to 5 only"),
                  // correctAnswer: Yup.string().required(
                  //   "Please select Correct Answer"
                  // ),
                  // optionDesc: Yup.string()
                  //   .required("Please Enter Options")
                  //   .max(200, "Option Descriptions Not Greater than 200"),
                  // optionDesc: Yup.string().when("resTypeId", {
                  //   is: (resTypeId) => (resTypeId === "2" ? true : false),
                  //   then: Yup.string()
                  //     .required("Please Enter Options")
                  //     .matches(
                  //       /^([0-9a-zA-Z ]\d*,[0-9a-zA-Z ]\d*,[0-9a-zA-Z ]\d*,[0-9a-zA-Z ]\d*)$/g,
                  //       "Please Enter 4 Options Only"
                  //     ),
                  //   otherwise: Yup.string()
                  //     .required("Please Enter Options")
                  //     .matches(
                  //       /^([0-9a-zA-Z ]\d*,[0-9a-zA-Z ]\d*)$/g,
                  //       "Please Enter 2 Options Only"
                  //     ),
                  // }),
                  // attemptOnly: Yup.string().required(
                  //   "Please select answer grade type"
                  // ),
                })
              ),
            })}
          >
            {({ values, errors, setFieldValue }) => (
              <Form>
                <div className="questionnaire">
                  <br></br>
                  <section className="create-parent questionnaire">
                    <div>
                      <FieldArray name="questionnaire">
                        {({ insert, remove, push }) => (
                          <div>
                            <label>
                              <h3>Create questionnaire</h3>
                            </label>

                            <button
                              type="button"
                              className="btn-8 ml-5 mr-5 mt-10"
                              onClick={() => {
                                console.log("Jerry", values);
                                if (values.questionnaire.length < 5) {
                                  const previousQue = values.questionnaire;
                                  previousQue.push({
                                    questionTitle: "",
                                    resTypeId: "",
                                    optionDesc: "",
                                    correctAnswer: "",
                                    score: "",
                                    // attemptOnly: "",
                                  });
                                  setFieldValue("questionnaire", previousQue);
                                } else {
                                  warning(
                                    "Only max. of 5 questions can be added",
                                    warningNotification
                                  );
                                }
                                console.log("Jerry", values);
                              }}
                            >
                              <h3>
                                {"  "}Add questions{" "}
                                <i class="fa fa-plus" aria-hidden="true"></i>
                              </h3>
                            </button>
                            <hr></hr>
                            {values.questionnaire.length > 0 &&
                              values.questionnaire.map((item, index) => (
                                <div className="row" key={index}>
                                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                    <div className="">
                                      <b>Question {index + 1} </b>
                                      <button
                                        type="button"
                                        className="btn-8 ml-5 mr-5 mt-10"
                                        onClick={() => {remove(index);
                                          // console.log('valuesqq',values.questionnaire);
                                          
                                          warning(`After Clicking the Remove Icon , Click on Save to Remove Question ${index + 1} `,warningNotification);
                                          // this.onSubmit(values,index,"remove")
                                      }
                                       }
                                      >
                                        <h3>
                                          Remove question no. {index + 1 + " "}{" "}
                                          <i
                                            class="fa fa-minus"
                                            aria-hidden="true"
                                          ></i>
                                        </h3>
                                      </button>

                                      <div className="row">
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>Question{" "}
                                          <span className="validation"> *</span>
                                          </label>
                                          <Field
                                          maxLength={100}
                                            component="textarea"
                                            name={`questionnaire.${index}.questionTitle`}
                                            placeholder="Type your question"
                                            type="text"
                                            title={values.questionnaire[index].questionTitle}
                                            className="form-control"
                                          />
                                          <ErrorMessage
                                            className="validation"
                                            component="div"
                                            name={`questionnaire.${index}.questionTitle`}
                                          />
                                        </div>
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                              <label>Select answer type{" "}
                              <span className="validation"> *</span></label>
                                          <Field
                                            as="select"
                                            type="text"
                                            name={`questionnaire.${index}.resTypeId`}
                                            className="form-control"
                                            title={values.questionnaire[index].resTypeId === "1" ?"Text":values.questionnaire[index].resTypeId === "2"?"MCQ":values.questionnaire[index].resTypeId === "3"?"Radio Button":""}
                                            onChange={(e) => {
                                              console.log(
                                                "e.target.value",
                                                e.target.value,
                                                values
                                              );

                                              setFieldValue(
                                                `questionnaire.${index}.resTypeId`,
                                                e.target.value
                                              );
                                              console.log(
                                                "e.target.value",
                                                e.target.value,
                                                values
                                              );
                                              if (
                                                e.target.value !== 1 ||
                                                e.target.value !== "1"
                                              ) {
                                                // ["2", 2].includes(
                                                //   e.target.value
                                                // )
                                                //   ? this.setState({
                                                //       idx: 4,
                                                //     })
                                                //   : ["3", 3].includes(
                                                //       e.target.value
                                                //     )
                                                //   ? this.setState({
                                                //       idx: 2,
                                                //     })
                                                //   : this.setState({
                                                //       idx: 0,
                                                //     });
                                                ["2", 2].includes(
                                                  e.target.value
                                                )
                                                  ? (values.questionnaire[
                                                      `${index}`
                                                    ].idx = 4)
                                                  : ["3", 3].includes(
                                                      e.target.value
                                                    )
                                                  ? (values.questionnaire[
                                                      `${index}`
                                                    ].idx = 2)
                                                  : (values.questionnaire[
                                                      `${index}`
                                                    ].idx = 0);
                                              }
                                            }}
                                          >
                                            <option value="selected">
                                              ----select----
                                            </option>
                                            {this.state.answerType.map((at) => (
                                              <option value={at.resTypeId}>
                                                {at.resTypeName}
                                              </option>
                                            ))}
                                          </Field>
                                          <ErrorMessage
                                            className="validation"
                                            component="div"
                                            name={`questionnaire.${index}.resTypeId`}
                                          />
                                        </div>
                                        {/* <div className="col-md-4 col-sm-4 col-xs-12">
                                          {/* <div>
                                            <label>Attemp Only</label>
                                            <br />
                                            <Field
                                              type="radio"
                                              name={`questionnaire.${index}.attemptOnly`}
                                              value="1"
                                            />
                                            &nbsp; YES &nbsp;&nbsp;&nbsp;
                                            <Field
                                              type="radio"
                                              name={`questionnaire.${index}.attemptOnly`}
                                              value="0"
                                            />
                                            &nbsp; NO
                                            <ErrorMessage
                                              className="validation"
                                              component="div"
                                              name={`questionnaire.${index}.attemptOnly`}
                                            />
                                          </div>
                                         
                                        </div>  */}

                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <div
                                            id={index}
                                            style={
                                              {
                                                // display:
                                                //   item.attemptOnly === "0"
                                                //     ? "block"
                                                //     : "none",
                                                // marginTop: "11px",
                                              }
                                            }
                                          >
                                            {/* <br /> */}
                                            <label>Score {" "}
                                            <span className="validation"> *</span>
                                            </label>
                                            <Field
                                              name={`questionnaire.${index}.score`}
                                              placeholder="Score"
                                              // type="number"
                                              type="text"
                                              className="form-control"
                                              // min="1"
                                              // max="5"
                                              title={values.questionnaire[index].score}
                                            />
                                            <ErrorMessage
                                              className="validation"
                                              component="div"
                                              name={`questionnaire.${index}.score`}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          {["2", 2, "3", 3].includes(
                                            item.resTypeId
                                          ) && (
                                            <div
                                              id={index}
                                              style={{
                                                display:
                                                  item.resTypeId === "1" ||
                                                  item.resTypeId === 1 ||
                                                  item.resTypeId ===
                                                    "selected" ||
                                                  item.resTypeId === undefined
                                                    ? "none"
                                                    : "block",
                                              }}
                                            >
                                              <label>Answer options{" "}
                                              <span className="validation"> *</span>
                                              </label>
                                              <Field
                                              maxLength={200}
                                                name={`questionnaire.${index}.optionDesc`}
                                                title={values.questionnaire[index].optionDesc}
                                                placeholder={
                                                  ["2", 2].includes(
                                                    item.resTypeId
                                                  )
                                                    ? "Option1,Option2,Option3,Option4"
                                                    : "Option1,Option2"
                                                }
                                                type="text"
                                                // component="textarea"
                                                className="form-control"
                                              />
                                              <ErrorMessage
                                                className="validation"
                                                component="div"
                                                name={`questionnaire.${index}.optionDesc`}
                                              />
                                              {/* {this.state.showOptions ===
                                            "block" ? (
                                              <ErrorMessage
                                                className="validation"
                                                component="div"
                                                name={`questionnaire.${index}.optionDesc`}
                                              />
                                            ) : (
                                              ""
                                            )} */}
                                              <p class="text-danger">
                                                Enter comma {"( , )"} seprated
                                                values.
                                                <br />
                                                eg. Option1,Option2
                                                {["2", 2].includes(
                                                  item.resTypeId
                                                ) && (
                                                  <span>,Option3,Option4</span>
                                                )}
                                              </p>
                                            </div>
                                          )}
                                        </div>
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          {["2", 2, "3", 3].includes(
                                            item.resTypeId
                                          ) && (
                                            <div
                                              id={index}
                                              style={{
                                                display:
                                                  item.resTypeId === "1" ||
                                                  item.resTypeId === 1 ||
                                                  item.resTypeId ===
                                                    "selected" ||
                                                  item.resTypeId === undefined
                                                    ? "none"
                                                    : "block",
                                              }}
                                            >
                                              {/* <br /> */}
                                              <label>Correct answer{" "}
                                              <span className="validation"> *</span>
                                              </label>
                                              <Field
                                                name={`questionnaire.${index}.correctAnswer`}
                                                placeholder="Select correct answer"
                                                // type="text"
                                                title={values.questionnaire[index].correctAnswer}
                                                as="select"
                                                className="form-control"
                                              >
                                                <option value="selected">
                                                  ----select{" "}
                                                  {item.optionDesc.toString}----
                                                </option>
                                                {/* {item.optionDesc
                                                  ? 
                                                      item.optionDesc.split(",").map((option, index) => (
                                                        index<((item.resTypeId == 2) ? 4 : 2)
                                                          ?
                                                          <option value={option}>
                                                            {option}
                                                          </option> 
                                                          :
                                                          ""
                                                      ))
                                                  : ""} */}
                                                {item.optionDesc
                                                  ? [
                                                      ...item.optionDesc.split(
                                                        ","
                                                      ),
                                                    ]
                                                      .slice(0, item.idx)
                                                      .map((option, index) => (
                                                        <option value={option}>
                                                          {option}
                                                        </option>
                                                      ))
                                                  : ""}
                                              </Field>
                                              <ErrorMessage
                                                className="validation"
                                                component="div"
                                                name={`questionnaire.${index}.correctAnswer`}
                                              />
                                              <label>{item.options}</label>
                                              {/* {this.state.showOptions ===
                                            "block" ? (
                                              <ErrorMessage
                                                className="validation"
                                                component="div"
                                                name={`questionnaire.${index}.correctAnswer`}
                                              />
                                            ) : (
                                              ""
                                            )} */}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <hr
                                      style={{
                                        borderTop: "4px solid rgb(226 153 63)",
                                      }}
                                    ></hr>
                                  </div>
                                </div>
                              ))}
                          </div>
                        )}
                      </FieldArray>
                    </div>
                    {/* <div className="row">
                      <div className="col-md-4 col-sm-4 col-xs-12">
                        <div>
                          <label>Total Score </label>
                          <Field
                            name="totalScore"
                            placeholder="Total Score"
                            type="number"
                            disabled
                            className="form-control"
                            value={this.state.totalScore}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-4 col-xs-12">
                        <label>Minimum Eligible Score </label>
                        <Field
                          name="minScore"
                          placeholder="Minimum Eligible Score"
                          type="number"
                          className="form-control"
                          value={this.state.minScore}
                          onChange={(e) => {
                            // console.log("e.target.value", e.target.value);
                            
                            this.setState({
                              minScore: parseInt(e.target.value),
                            });
                          }}
                        />
                      </div>
                    </div>

                    <br></br> */}

                    <button
                      className="btn btn-primary float-right"
                      type="button"
                      onClick={() => this.onSubmit(values,null,"add")}
                    >
                      Save
                    </button>
                  </section>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </React.Fragment>
    );
  }
}

export default questionnaire;
